'use strict';

Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

const react = require('@emotion/react');
const styleEncapsulation = require('@zapier/style-encapsulation');
const React = require('react');
const theme_Colors = require('../../../../theme/Colors.cjs.js');
require('../../../../theme/Shadows.cjs.js');
require('../../../../theme/Typography.cjs.js');
const theme_LegacyTypography = require('../../../../theme/LegacyTypography.cjs.js');
const theme_LegacyColorMap = require('../../../../theme/LegacyColorMap.cjs.js');
const components_display_Heading_Heading = require('../../../display/Heading/Heading.cjs.js');
require('../../../../utils/heading-level-context/HeadingLevelContext.cjs.js');
const components_display_Icon_Icon = require('../../../display/Icon/Icon.cjs.js');
const components_display_Tag_Tag = require('../../../display/Tag/Tag.cjs.js');
const components_display_Text_Text = require('../../../display/Text/Text.cjs.js');
require('../../SubscriptionForm/SubscriptionForm.cjs.js');
const components_marketing_SubscriptionForm_SubscriptionFormWithDisclaimer = require('../../SubscriptionForm/SubscriptionFormWithDisclaimer.cjs.js');
require('../../SubscriptionForm/DisclaimerText.cjs.js');
const components_layout_Grid_Grid = require('../../../layout/Grid/Grid.cjs.js');
const components_navigation_Button_Button = require('../../../navigation/Button/Button.cjs.js');
const components_marketing_Hero_constants = require('../constants.cjs.js');
const components_marketing_Hero_utils = require('../utils.cjs.js');
const styleMixins_reset = require('../../../../style-mixins/reset.cjs.js');

const SubscriptionFormStyles = {
  ctaContainer: react.css`
    ${styleMixins_reset.boxSizing};
    @media screen and (min-width: ${components_marketing_Hero_constants.breakpoints.tablet}px) {
      align-items: stretch;
      flex-direction: column;
    }

    // Button shouldn't take up full width when subscription form is enabled;
    button,
    a {
      width: auto;
    }
  `,
  ctaDisclaimer: react.css`
    ${styleMixins_reset.boxSizing};
    margin: 10px 0;
    @media screen and (min-width: ${components_marketing_Hero_constants.breakpoints.tablet}px) {
      margin: 10px 0;
    }
    @media screen and (max-width: ${components_marketing_Hero_constants.breakpoints.mobile}px) {
      text-align: left;
    }
  `
};
const Styles = styleEncapsulation.labelStyles("Hero", {
  root: (backgroundColor = "neutral100") => react.css`
    ${styleMixins_reset.boxSizing};
    background-color: ${theme_Colors.Colors[theme_LegacyColorMap.LegacyColorMap[backgroundColor]]};
    padding: 20px;
    @media screen and (min-width: ${components_marketing_Hero_constants.breakpoints.tablet}px) {
      padding: 40px;
    }
  `,
  content: (maxWidth) => react.css`
    ${styleMixins_reset.boxSizing};
    display: grid;
    align-items: center;
    grid-template-columns: repeat(1, 1fr);
    gap: 40px;
    max-width: ${maxWidth}px;
    margin: 0 auto;

    @media screen and (min-width: ${components_marketing_Hero_constants.breakpoints.tablet}px) {
      grid-template-columns: repeat(2, 1fr);
    }
  `,
  labelContainer: react.css`
    ${styleMixins_reset.boxSizing};
    margin-bottom: 10px;
  `,
  heading: (backgroundColor = "neutral100") => react.css`
    ${styleMixins_reset.boxSizing};
    ${theme_LegacyTypography.LegacyTypography.pageHeader4}
    color: ${theme_Colors.Colors[components_marketing_Hero_utils.mapBackgroundColorToV5TextColorName(backgroundColor)]};
    margin-bottom: 10px;

    @media screen and (min-width: ${components_marketing_Hero_constants.breakpoints.tablet}px) {
      ${theme_LegacyTypography.LegacyTypography.pageHeader3}
      margin-bottom: 20px;
    }
  `,
  description: (backgroundColor = "neutral100") => react.css`
    ${styleMixins_reset.boxSizing};
    ${theme_LegacyTypography.LegacyTypography.pageHeader9}
    color: ${theme_Colors.Colors[components_marketing_Hero_utils.mapBackgroundColorToV5HeadingColorName(backgroundColor)]};
  `,
  textContent: react.css`
    ${styleMixins_reset.boxSizing};
    max-width: 470px;
    text-align: center;
    margin: 0 auto;

    @media screen and (min-width: ${components_marketing_Hero_constants.breakpoints.tablet}px) {
      margin: 0;
      text-align: left;
    }
  `,
  mediaContent: react.css`
    ${styleMixins_reset.boxSizing};
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
  `,
  ctaContainer: (isSubscriptionForm = false) => react.css`
    ${styleMixins_reset.boxSizing};
    margin-top: 20px;
    text-align: center;

    @media screen and (min-width: ${components_marketing_Hero_constants.breakpoints.tablet}px) {
      margin-top: 40px;
      display: flex;
      align-items: center;
      text-align: left;
    }
    ${isSubscriptionForm && styleEncapsulation.withModifier("subscription-form", SubscriptionFormStyles.ctaContainer)}
  `,
  ctaDisclaimer: (isSubscriptionForm = false) => react.css`
    ${styleMixins_reset.boxSizing};
    margin: 10px auto 0 auto;
    @media screen and (min-width: ${components_marketing_Hero_constants.breakpoints.tablet}px) {
      margin-top: 0;
      margin-left: 20px;
    }

    ${isSubscriptionForm && styleEncapsulation.withModifier("subscription-form-disclaimer", SubscriptionFormStyles.ctaDisclaimer)}
  `
});
const HeroStandard = ({ backgroundColor = "neutral100", ctaColor = "primary", isSubscriptionForm = false, subscriptionPlaceholder = "Email address", heading, description, ctaText, ctaHref, ctaTarget, ctaDisabled = false, ctaDisclaimer, onCtaClick, onCtaKeyDown, onSubscriptionFormSubmit, children, maxWidth = 1170, label, labelIcon, labelColor }) => {
  const mappedBackgroundColor = components_marketing_Hero_utils.transformBackgroundColor(backgroundColor);
  components_marketing_Hero_utils.validateZapierBackgroundAccessibility(mappedBackgroundColor, isSubscriptionForm, !!ctaDisclaimer);
  const getCtaComponent = () => {
    const sharedProps = {
      children: ctaText,
      href: !isSubscriptionForm ? ctaHref : void 0,
      onClick: onCtaClick,
      onKeyDown: onCtaKeyDown,
      isFullWidth: true,
      size: isSubscriptionForm ? "medium" : "large",
      type: isSubscriptionForm ? "submit" : "button",
      target: ctaTarget,
      disabled: ctaDisabled
    };
    const color = components_marketing_Hero_utils.getSupportedCTAColor(ctaColor, mappedBackgroundColor);
    return react.jsx(components_navigation_Button_Button.Button, Object.assign({}, sharedProps, { color: color === "primary-alt" ? "primary" : color }));
  };
  const isDisclaimerElement = !!ctaDisclaimer && React.isValidElement(ctaDisclaimer);
  return react.jsx(
    "div",
    { css: Styles.root(mappedBackgroundColor), "data-zds": true },
    react.jsx(
      "div",
      { css: Styles.content(maxWidth), "data-zds": true },
      react.jsx(
        "div",
        { css: Styles.textContent, "data-zds": true },
        label && react.jsx(
          "div",
          { css: Styles.labelContainer, "data-zds": true },
          react.jsx(components_display_Tag_Tag.Tag, { variant: labelColor }, labelIcon ? react.jsx(
            components_layout_Grid_Grid.Grid,
            { alignItems: "center", columns: "auto max-content", gap: 5 },
            react.jsx(components_display_Icon_Icon.Icon, { name: labelIcon, size: 20 }),
            label
          ) : label)
        ),
        react.jsx(components_display_Heading_Heading.Heading, { css: Styles.heading(mappedBackgroundColor) }, heading),
        description && react.jsx("div", { css: Styles.description(mappedBackgroundColor), "data-zds": true }, description),
        ctaText && (ctaHref || onCtaClick || isSubscriptionForm) && react.jsx("div", { css: Styles.ctaContainer(isSubscriptionForm), "data-zds": true }, isSubscriptionForm ? react.jsx(components_marketing_SubscriptionForm_SubscriptionFormWithDisclaimer.SubscriptionFormWithDisclaimer, { placeholderText: subscriptionPlaceholder, onSubmit: onSubscriptionFormSubmit, renderButton: () => getCtaComponent(), disclaimerTextColor: mappedBackgroundColor === "neutral100" ? "primary" : "secondary" }) : react.jsx(
          React.Fragment,
          null,
          react.jsx("div", { "data-zds": true }, getCtaComponent()),
          ctaDisclaimer && react.jsx("div", { css: Styles.ctaDisclaimer(isSubscriptionForm), "data-zds": true }, isDisclaimerElement ? ctaDisclaimer : react.jsx(components_display_Text_Text.Text, { tag: "p", type: "Body1", color: components_marketing_Hero_utils.mapBackgroundColorToV5HeadingColorName(mappedBackgroundColor) }, ctaDisclaimer))
        ))
      ),
      react.jsx("div", { css: Styles.mediaContent, "data-zds": true }, children)
    )
  );
};

exports.HeroStandard = HeroStandard;
//# sourceMappingURL=HeroStandard.cjs.js.map
